// extracted by mini-css-extract-plugin
export default {"formItem":"style_formItem__tm4nO","formItemLabel":"style_formItemLabel__FIIBT","star":"style_star__hwX46"};